export default __webpack_public_path__ + "static/media/supportChatQIcon.8e2e5e94.svg";